export enum FilterMatcher {
    AND = 'and',
    OR = 'or',
}

export enum FilterOperator {
    ANY_OF = 'any_of',
    ALL_OF = 'all_of',
    NONE_OF = 'none_of',
    LESS_THAN = 'less_than',
    LESS_OR_EQUAL = 'less_or_equal',
    GREATER_THAN = 'greater_than',
    GREATER_OR_EQUAL = 'greater_or_equal',
}

export enum TransactionICExtendedType {
    WALLET_CREDIT_IC = 'WALLET_CREDIT_IC',
}

export enum TransactionExtendedType {
    PURCHASE = 'PURCHASE',
    CASH_WITHDRAWAL = 'CASH_WITHDRAWAL',
    REFUND = 'REFUND',
    BALANCE_INQUIRY = 'BALANCE_INQUIRY',
    ACCOUNT_VERIFICATION = 'ACCOUNT_VERIFICATION',
    WALLET_DEBIT = 'WALLET_DEBIT',
    WALLET_CREDIT = 'WALLET_CREDIT',
    WALLET_TRANSFER = 'WALLET_TRANSFER',
    WALLET_TRANSFER_FX = 'WALLET_TRANSFER_FX',
    WALLET_DEBIT_REVERSAL = 'WALLET_DEBIT_REVERSAL',
    WALLET_CREDIT_REVERSAL = 'WALLET_CREDIT_REVERSAL',
    QUASI_CASH = 'QUASI_CASH',
    INITIAL_LOAD = 'INITIAL_LOAD',
    OCT = 'OCT',
    AFT = 'AFT',
    WALLET_DEBIT_MONEYGRAM = 'WALLET_DEBIT_MONEYGRAM',
    WALLET_DEBIT_REVERSAL_MONEYGRAM = 'WALLET_DEBIT_REVERSAL_MONEYGRAM',
    // QR_PAYMENTS = "QR_PAYMENTS",
    // QR_PAYMENTS_VOID=  "QR_PAYMENTS_VOID",
    // QR_PAYMENTS_REFUND = "QR_PAYMENTS_REFUND",
    // NCPGS_TRANSFER = 'NCPGS_TRANSFER',
    FUNDS_TRANSFER = 'FUNDS_TRANSFER',
    EXCHANGE_TRANSFER = 'EXCHANGE_TRANSFER',
    WALLET_TOP_UP_VIA_CARD = 'WALLET_TOP_UP_VIA_CARD',
    UTILITY_PAYMENT = 'UTILITY_PAYMENT',
}

export enum MessageType {
    AUTHORIZATION = 'AUTHORIZATION',
    AUTHORIZATION_ADVICE = 'AUTHORIZATION_ADVICE',
    REVERSAL = 'REVERSAL',
    FINANCIAL = 'FINANCIAL',
    FINANCIAL_ADVICE = 'FINANCIAL_ADVICE',
    REVERSAL_ADVICE = 'REVERSAL_ADVICE',
    CLEARING = 'CLEARING',
    CLEARING_REVERSAL = 'CLEARING_REVERSAL',
    API = 'API',
}

export enum AuthExpiredByType {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
}

export enum ConfirmationType {
    YES = 'YES',
    NO = 'NO',
}

export enum TransferSourceChannel {
    API = 'API',
    DAPI = 'DAPI',
    MPGS = 'MPGS',
    MONEYGRAM = 'MONEYGRAM',
    QR_PAYMENTS = 'QR_PAYMENTS',
    QR_PAYMENTS_VOID = 'QR_PAYMENTS_VOID',
    QR_PAYMENTS_REFUND = 'QR_PAYMENTS_REFUND',
    NCPGS = 'NCPGS',
    EXTERNAL = 'EXTERNAL',
    ARPG = 'ARPG',
}

export enum LoadTransactionType {
    HOLD = 'HOLD',
    POST = 'POST',
    RELEASE = 'RELEASE',
}

export enum EcommerceSecurityLevel {
    THREE_DS_ONE = '3DS1',
    THREE_DS_TWO = '3DS2',
    THREE_DS_TWO_POINT_TWO = '3DS2.2',
}

export enum CardEntry {
    UNKNOWN = 'UNKNOWN',
    MANUAL_ENTRY = 'MANUAL_ENTRY',
    MAGNETIC_STRIPE = 'MAGNETIC_STRIPE',
    ICC = 'ICC',
    CARD_ON_FILE = 'CARD_ON_FILE',
}

export enum PosEnvironment {
    UNKNOWN = 'UNKNOWN',
    ATTENDED_POS = 'ATTENDED_POS',
    ECOMMERCE = 'ECOMMERCE',
}
export enum WalletType {
    FUNDS_TRANSFER = 'FUNDS_TRANSFER',
    BILL_PAYMENT = 'BILL_PAYMENT',
    CURRENCY_EXCHANGE = 'CURRENCY_EXCHANGE',
    LOAD_CHECKOUT = 'LOAD_CHECKOUT',
    LOAD_LEAN = 'LOAD_LEAN',
    REMITTANCES = 'REMITTANCES',
    QR_PAYMENTS = 'QR_PAYMENTS',
    QR_PAYMENTS_VOID = 'QR_PAYMENTS_VOID',
    QR_PAYMENTS_REFUND = 'QR_PAYMENTS_REFUND',
    NCPGS_TRANSFER = 'NCPGS_TRANSFER',
    UNLOAD_EXTERNAL = 'UNLOAD_EXTERNAL',
    ECOMMERCE = 'ECOMMERCE',
    WALLET_DEBIT = 'WALLET_DEBIT',
    WALLET_CREDIT = 'WALLET_CREDIT',
    WALLET_DEBIT_REVERSAL = 'WALLET_DEBIT_REVERSAL',
}
export enum TransactionFilterType {
    COMPLETION = 'COMPLETION',
    POST = 'POST',
    HOLD = 'HOLD',
    RELEASE = 'RELEASE',
}

export enum TransactionFilterSourceChannel {
    QR_PAYMENTS = 'QR_PAYMENTS',
    NCPGS = "NCPGS"


}

export enum ChargeFilterType {
    MAINTENANCE = 'MAINTENANCE',
}
